import {
  ChangeEvent,
  FC,
  FormEvent,
  useContext,
  useEffect,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import { ConnectionContext } from "../contexts/ConnectionProviderContext";
import { Program } from "@project-serum/anchor";
import { TweeterDapp } from "../types/tweeter_dapp";
import TweetsContainer from "../utils/TweetsContainer";
import KeyIcon from "../assets/key.svg";
import { LikeContext } from "../contexts/LikesContext";
import setTweetsWithUserLike from "../utils/Tweets";

const Users: FC = () => {
  const params = useParams();
  const [userInput, setUserInput] = useState("");
  const [fetchTweets, setFetchTweets] = useState<Boolean>(false);
  const [userTweets, setUserTweets] = useState<any | null>([]);
  const { workSpace }: any = useContext(ConnectionContext);
  const {allLikes, userLikes}: any = useContext(LikeContext);
  const program = workSpace.program as Program<TweeterDapp>;
  const wallet = workSpace.wallet;
  useEffect(() => {
    (async () => {
      try {
        if (params.userid === "user") {
          return;
        }

        const tweets = await program.account.tweet.all([
          {
            memcmp: {
              offset: 8,
              bytes: params?.userid || wallet.publicKey,
            },
          },
        ]);
        if (tweets) {
        const tweetsWithUserLikes = setTweetsWithUserLike(allLikes,tweets,userLikes);
          setUserTweets(tweetsWithUserLikes);
        }
      } catch (error) {
        console.log("Error from user", error);
      }
    })();
  }, [params.userid, wallet]);

  const userInputHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setUserInput(input);
  };

  const userTweetsHandler = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!userInput) {
      alert("Enter a public key!");
      return;
    }

    try {
      const tweets = await program.account.tweet.all([
        {
          memcmp: {
            offset: 8,
            bytes: userInput,
          },
        },
      ]);
      const tweetsWithUserLikes =setTweetsWithUserLike(allLikes,tweets,userLikes);
      setUserTweets(tweetsWithUserLikes);
      setUserInput("");
      setFetchTweets(true);
    } catch (error) {
      alert("Something went wrong");
    }
  };

  return (
    <main className=" pt-5 gap-4 col-start-3 col-span-12 px-2 md:row-start-7 md:col-start-3 md:col-span-7 md:pt-8 md:items-end xl:col-start-5 xl:col-span-4">
      <h1 className="text-center pb-2 font-medium text-lg">User Page</h1>
      <form
        onSubmit={userTweetsHandler}
        className="col-start-5 col-span-4 place-self-center rounded-md border-2 border-gray-300 p-4"
      >
        <fieldset className="mb-2 flex flex-col content-center space-x-4 items-center md:flex-row md:items-end md:justify-center">
          <div className="flex space-x-2">
            <img src={KeyIcon} alt="wallet public key"></img>
            <input
              name={"walletKey"}
              onChange={userInputHandler}
              placeholder="enter wallet address..."
              className="bg-gray-100 p-2 mt-1 w-60 sm:w-96 focus:outline-none rounded-2xl text-sm md:w-60 md:text-base lg:w-80"
              value={userInput}
            ></input>
          </div>
          <button
            type="submit"
            className="bg-blue-400 text-white p-2 mt-4 hover:bg-blue-500 rounded-md w-24 min-w-max text-sm md:text-base"
          >
            Search
          </button>
        </fieldset>
      </form>
      {fetchTweets && userTweets.length === 0 && (
        <h1 className="text-center py-2 text-xl font-extrabold text-blue-400">
          No tweets yet!
        </h1>
      )}

      <TweetsContainer tweets={userTweets} />
    </main>
  );
};

export default Users;
